import { render, staticRenderFns } from "./UnsyncedBar.vue?vue&type=template&id=67374e4d&scoped=true&"
var script = {}
import style0 from "./UnsyncedBar.vue?vue&type=style&index=0&id=67374e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67374e4d",
  null
  
)

export default component.exports